<template>
	<div :class="{'avue--collapse': isCollapse}" class="avue-contail u-relative">
		<!-- 悬浮提示 -->
		<!-- <div class="floating-tip" v-if="!isShowCollectTip">
			<el-alert title="成功提示的文案" type="warning" center show-icon>
				<template #title>
					<div class="u-flex u-row-center">
						<span>
							您已完成升级切换，但请务必按【
							<span style="color: #409eff; cursor: pointer">Ctrl+D</span>
							】收藏本网站，避免后续走失！
						</span>
						<div class="u-m-l-20">
							<el-button type="text" size="small" @click="onCollectYet">我已收藏</el-button>
						</div>
					</div>
				</template>
			</el-alert>
		</div> -->

		<!-- 主体 -->
		<div v-if="!difChannelType.isFullScreen">
			<div class="avue-header">
				<!-- 顶部导航栏 -->
				<top />
			</div>
			<div class="avue-layout">
				<div class="avue-left">
					<!-- 左侧导航栏 -->
					<sidebar />
				</div>
				<div class="avue-main">
					<!-- 顶部标签卡 -->
					<tags />
					<!--提示-->
					<transition name="fade">
						<NoticesHint ref="refNoticesHint" :isShow.sync="isShowHint"></NoticesHint>
					</transition>

					<!-- 主体视图层 -->
					<div
						id="avue-view"
						:style="isShowHint ? {height: 'calc(100% - 80px)'} : {height: 'calc(100% - 40px)'}"
						style="overflow-y: auto; overflow-x: hidden">
						<keep-alive>
							<router-view v-if="$route.meta.keepAlive" :key="$route.fullPath" class="avue-view" />
						</keep-alive>
						<router-view v-if="!$route.meta.keepAlive" class="avue-view" />

						<div v-for="iframeItem in getIframeTagList" :key="iframeItem.value">
							<entry-center-url
								v-show="$route.fullPath === iframeItem.value"
								:iframe-url="iframeItem.value"></entry-center-url>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else style="height: calc(100%); overflow-y: auto; overflow-x: hidden">
			<keep-alive>
				<router-view v-if="$route.meta.keepAlive" :key="$route.fullPath" class="avue-view" />
			</keep-alive>
			<router-view v-if="!$route.meta.keepAlive" class="avue-view" />
		</div>
		<div class="avue-shade" @click="showCollapse" />

		<div v-if="isShowUpdate" class="update-hint">
			<div class="hint-header">
				<div class="warning-icon">
					<el-icon class="el-icon-warning"></el-icon>
				</div>
				<span class="hint-title">提示</span>
			</div>
			<div class="hint-content">检测到新版本，请及时更新！</div>
			<div class="hint-footer">
				<el-button type="primary" class="update-btn" @click="handleUpdate">更新</el-button>
			</div>
		</div>

		<!-- 常见问题悬浮组件 -->
		<FrequentQuestions />
	</div>
</template>

<script>
import NoticesHint from '@/components/noticesHint.vue'
import FrequentQuestions from '@/components/common/FrequentQuestions.vue'
import store from '@/store'
import admin from '@/util/admin'
import {getStore, setStore} from '@/util/store.js'
import {getVersionData} from '@/util/version'
import EntryCenterUrl from '@/views/insuranceCenter/entryCenterUrl.vue'
import * as SockJS from 'sockjs-client'
import Stomp from 'stomp-websocket'
import {mapGetters} from 'vuex'
import sidebar from './sidebar/'
import tags from './tags'
import top from './top/'
import {isIframe} from '@/util/channelUtil'
export default {
	name: 'Index',
	provide() {
		return {
			Index: this,
		}
	},
	components: {
		EntryCenterUrl,
		NoticesHint,
		FrequentQuestions,
		top,
		tags,
		sidebar,
	},
	data() {
		return {
			// 刷新token锁
			refreshLock: false,
			// 刷新token的时间
			refreshTime: '',
			// 计时器
			timer: '',
			isShowHint: false,
			isShowUpdate: false,
			// 检测更新计时器
			checkUpdateTimer: '',
			isShowCollectTip: true,
		}
	},
	created() {
		// 实时检测刷新token
		// this.refreshToken()
		// //是否收藏
		// this.isShowCollectTip = isIframe() || getStore({name: 'isShowCollectTip'})
	},
	destroyed() {
		if (this.refreshTime) {
			clearInterval(this.refreshTime)
		}
		if (this.timer) {
			clearInterval(this.timer)
		}
		if (this.checkUpdateTimer) {
			clearInterval(this.checkUpdateTimer)
		}
		if (this.$refs.refNoticesHint) {
			this.$refs.refNoticesHint.clearInterval()
		}
		/*
		 * 默认关闭websocket，如需工作流通知，则开启
		 * this.disconnect()
		 */
	},
	mounted() {
		this.init()
		/*
		 * 默认关闭websocket，如需工作流通知，则开启
		 * this.initWebSocket()
		 */
		//判断是否需要强制更新版本
		//内嵌页面不更新
		if (!isIframe()) {
			//立即执行一次
			this.getVersion()
			this.checkUpdate()
		}
	},
	computed: {
		...mapGetters(['userInfo', 'isLock', 'isCollapse', 'website', 'expires_in', 'difChannelType', 'tagList']),
		getIframeTagList() {
			return this.tagList.filter(({value}) => value.includes('entryCenterUrl')) || []
		},
	},
	methods: {
		showCollapse() {
			this.$store.commit('SET_COLLAPSE')
		},
		openMenu(item = {}) {
			this.$store.dispatch('GetMenu', {type: true, id: item.id}).then((data) => {
				if (data.length !== 0) {
					this.$router.$avueRouter.formatRoutes(data, true)
				}
			})
			if (item.path && (item.path.startsWith('http://') || item.path.startsWith('https://'))) {
				window.open(item.path, '_blank')
			}
		},
		// 屏幕检测
		init() {
			this.$store.commit('SET_SCREEN', admin.getScreen())
			window.onresize = () => {
				setTimeout(() => {
					this.$store.commit('SET_SCREEN', admin.getScreen())
				}, 0)
			}
		},
		// 实时检测刷新token
		refreshToken() {
			this.refreshTime = setInterval(() => {
				const token = getStore({
					name: 'access_token',
					debug: true,
				})
				if (this.validatenull(token)) {
					return
				}
				if (this.expires_in <= 1000 && !this.refreshLock) {
					this.refreshLock = true
					this.$store.dispatch('RefreshToken').catch(() => {
						clearInterval(this.refreshTime)
					})
					this.refreshLock = false
				}
				this.$store.commit('SET_EXPIRES_IN', this.expires_in - 10)
			}, 10000)
		},
		initWebSocket() {
			this.connection()
			const self = this
			// 断开重连机制,尝试发送消息,捕获异常发生时重连
			this.timer = setInterval(() => {
				try {
					self.stompClient.send('test')
				} catch (err) {
					console.log('断线了: ' + err)
					self.connection()
				}
			}, 5000)
		},
		//循环查询检测更新
		checkUpdate() {
			this.checkUpdateTimer = setInterval(this.getVersion, 5 * 60 * 1000)
		},
		// 检查更新
		getVersion() {
			getVersionData()
				.then(() => {
					this.isShowUpdate = true
				})
				.catch(() => {
					this.isShowUpdate = false
				})
		},
		connection() {
			const token = store.getters.access_token
			const TENANT_ID = getStore({name: 'tenantId'}) ? getStore({name: 'tenantId'}) : '1'
			const headers = {
				'TENANT-ID': TENANT_ID,
				Authorization: 'Bearer ' + token,
			}
			// 建立连接对象
			this.socket = new SockJS('/act/ws') // 连接服务端提供的通信接口，连接以后才可以订阅广播消息和个人消息
			// 获取STOMP子协议的客户端对象
			this.stompClient = Stomp.over(this.socket)
			this.stompClient.debug = null
			// 向服务器发起websocket连接
			this.stompClient.connect(
				headers,
				() => {
					// 订阅通道  /task/租户ID/用户名称/remind
					let target = `/task/${TENANT_ID}/${this.userInfo.username}/remind`
					this.stompClient.subscribe(target, (msg) => {
						// 订阅服务端提供的某个topic;
						this.$notify({
							title: '协同提醒',
							type: 'warning',
							dangerouslyUseHTMLString: true,
							message: msg.body + '任务，请及时处理',
							offset: 60,
						})
					})
				},
				(err) => {
					console.log(err)
				},
			)
		},
		disconnect() {
			if (this.stompClient != null) {
				this.stompClient.disconnect()
				console.log('Disconnected')
			}
		},
		// 添加更新处理方法
		handleUpdate() {
			window.location.reload(true)
		},
		// onCollectYet() {
		// 	setStore({name: 'isShowCollectTip', content: true})
		// 	this.isShowCollectTip = true
		// },
	},
}
</script>

<style scoped lang="scss">
::v-deep .el-alert--info.is-light {
	background-color: rgba(116, 176, 238, 0.11);
}

.floating-tip {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	z-index: 2000;
	animation: bounce-in 0.5s ease-out;
}

.update-hint {
	position: fixed;
	top: 105px;
	right: 10px;
	width: 300px;
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	overflow: hidden;
	z-index: 2000;
	padding: 16px;
	animation: bounce-in 0.5s ease-out;

	.hint-header {
		display: flex;
		align-items: center;
		margin-bottom: 16px;
		padding: 5px 10px;
		border-radius: 8px;
		//左右渐变 微红到透明
		background: linear-gradient(to left, rgba(242, 125, 127, 0), rgba(242, 125, 127, 0.1));

		.warning-icon {
			display: flex;
			align-items: center;
			justify-content: center;
			color: #ff4d4f;
			margin-right: 8px;

			i {
				font-size: 24px;
			}
		}
		.hint-title {
			font-size: 16px;
			color: #ff4d4f;
			font-weight: 500;
		}
	}

	.hint-content {
		font-size: 14px;
		color: #303133;
		font-weight: 500;
		line-height: 1.6;
		margin-bottom: 16px;
		margin-left: 10px;
	}

	.hint-footer {
		display: flex;
		justify-content: center;

		.update-btn {
			padding: 8px 30px;
			border-radius: 6px;
		}
	}
}

@keyframes bounce-in {
	0% {
		transform: translateX(100%);
		opacity: 0;
	}
	60% {
		transform: translateX(-10px);
		opacity: 1;
	}
	100% {
		transform: translateX(0);
	}
}

::v-deep .el-alert__title {
	font-size: 16px;
	font-weight: bold;
	color: #303133;
}
::v-deep .el-icon-close:before {
	font-size: 18px;
	font-weight: bold;
}

::v-deep .el-alert {
	height: 50px;
}
</style>
